import React from "react";
import LearnMore from "../../../../components/learnMore/learnMore";

const MembershipBreakdownLearnMore = ({ organizationName }) => {
  return <LearnMore title="Membership Breakdown" content={getContent(organizationName)} html />;
};

const getContent = (organizationName) => {
  return `
      The <b>Membership Breakdown</b> table and pie chart allows you to explore your memberships in order to discover insights into revenue and composition.
      <br />
      <br />
      <b>Filters</b>
      </br>
      </br>
      <b>Group By:</b></br>
       This changes aggregation of memberships. We will group the members by the filter. <br />
      <b>Revenue Category</b> will show all data in groupings by the Sales Package folder in ClubReady. If your brand is manually mapping
       data into categories, this data will no longer match the folders.
       </br>
       </br>
      <b>Membership</b> will show all data by the membership package. This is the one setting where iKizmet is not grouping packages together. </br>
      <b>Membership Type</b> (default) will show all data in groupings by the Membership Type in ClubReady.
      </br>
      </br>
      <b>Include $0 Sales:</b></br>
      This dropdown can exclude or include $0 sales from the average membership calculation. When you check Yes (default), the paying members column and avg. per member columns <i>will</i> include members with $0 sales.
      When the No is selected, the paying members column and avg. per member columns <i>don’t</i> include members with $0 sales. We will exclude those $0 sales.
      </br>
      </br>
      <i>Table Columns will be based on the Status Type and Group by filters.</i>
      </br>
      </br>
      <b>Membership Type, Membership or Revenue Category:</b> Depending on the Status Type filter, this will show the different of groupings of members.  
      <br />
      <br />
      <b>Active:</b>
      <br />
      This metric will only show those active members who are not frozen. Active will be the sum of Paying and Non-Paying
      <br />
      <br />
      <b>New MTD:</b>
      <br />
      This metric will only show those new members. This data point is always month-to-date based date selected on the calendar.
      <br />
      <br />
      <b>Paying:</b>
      <br />
      We look at Active members and determine if they have paid based on the agreement. 
      If they did not pay based on that payment window, they will be moved to Non-Paying. 
      This number will not include Frozen members. If a member has a $0 invoice, they will still be considered Paying if the Yes is checked in the Include $0 Sales filter. 
      When the No is selected, those $0 Sales will not show in Paying but be moved to Non-Paying column.
      <br />
      <br />
      <b>Non-Paying:</b>
      <br />
      Members that do not have a payment/invoice during the last payment duration period according to their agreement. For example: If a member is required to make a payment every month according to their agreement and there is no payment in the last month, the member will be counted as a non-paying member. Non-paying members can include members whose last payment was declined or invoice removed. Depending on the Include $0 Sales filter, a member who has an invoice that shows $0, may or may not be included.
      <br />
      When the Yes is selected, those $0 Sales will be shown in Paying.
      <br />
      When the No is selected, those $0 Sales will be shown in Non-Paying.
      <br />
      <br />
      <b>Past Dues:</b>
      <br />
      Of the Non-Paying members, this will highlight those that are Non-Paying due to past dues.<br/>
      <i>This data is only available for the current date selected. No historical data is saved in ClubReady to display. When selecting a date in the past, this column will not be visible.</i>
      <br />
      <br />
      <b>Frozen:</b>
      <br />
      Count of members with frozen status.
      <br />
      <br />
      ${
        organizationName !== "Mayweather"
          ? `
            <b>Revenue:</b>
          <br />
          Total revenue of the paying members or New MTD members depending on the first filter.
          <br />
          <br />`
          : ""
      }
      <b>Avg. Revenue Per Paying Member:</b>
      <br />
      Total revenue collected of the paying members (total paying revenue divided by the number of paying members).
      <br />
      <br />
      <b>Avg. Revenue Per New Member:</b><br />
      Total revenue collected of the new MTD members (total revenue divided by the number of new MTD members).
      <br />
      <br />
      <b>Avg. Revenue Per EFT:</b><br />
      If the sales package is evergreen/recurring, we will count the total revenue collected of those new EFT only members (total revenue divided by the number of new MTD members).
      <br />
      <br />
      Because the setup, discounting and manual input can vary from brand to brand, the following is how we calculate the averages:<br/>
      The calculation looks at the second invoice in the series. The first invoice could be discounted, added a setup fee or waived causing issues with the calculation. If there is no second invoice in the series, we will then look at the agreement data to determine the amount of the invoice. 
      All revenue from second invoice in the series is included in the EFT calculation even if it was Refunded or Returned.
      <br />
      <br />
        ${
          organizationName !== "Mayweather"
            ? `
          <b>Revenue %:</b>
          <br />
           The percentage of the grouping or agreement/package revenue contributes to the Membership revenue.
          <br />
          <br />`
            : ""
        } 
      <b>Membership %:</b>
      <br />
      The percentage of the grouping or agreement/package members contributes to the total membership count. 
      <br />
      <br />
      <b>Pie Chart:</b>
      <br />
      Visual representation of the Membership %
      <br />
      <br />
    `;
};

export default MembershipBreakdownLearnMore;
